import React from 'react';
import styled from 'styled-components';
import { Document } from '@contentful/rich-text-types';

const FlyinContainer = styled.div`
    position: fixed;
    right: 0;
    top: 35vh;
    z-index: 5;
    transition: all 0.5s ease-in-out;
    width: 0;
    &.isOpen {
        width: 600px;
        @media (max-width: 768px) {
            width: 100%;
        }
    }
`;

const Button = styled.a`
    right: -40px;
    margin-top: 50px;
    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 3px;
      background-color: #46ff46;
      transition: all .3s ease-in-out 0s;
      transform: scaleX(1);
    }
`;

interface FlyinProps {
    heading: string;
    form?: {
        heading: Document;
        formHtml: string;
    };
}

export const Flyin = ({ heading }: FlyinProps) => {
    return (
        <FlyinContainer>
            <div className={`pl-5 py-5 border border-stone bg-stone`}>
                <Button href="/newsletter" className={`absolute uppercase transform rotate-90`}>
                    {heading}
                </Button>
            </div>
        </FlyinContainer>
    );
};
